// These values need to match the values returned from the Edge Service.
// See 'DateGranularity' in the Edge Service:
// tslint:disable-next-line: max-line-length
// https://gitlab.tableausoftware.com/metrics/service/edge/metrics-edge-service/blob/master/src/main/kotlin/com/tableau/metrics/edge/grpc/p4/json/MetricDataPoints.kt
export enum DateTrunc {
  YEAR = 'year',
  QUARTER = 'quarter',
  MONTH = 'month',
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
  SECOND = 'second',
  WEEK = 'week',
  ISO_YEAR = 'iso-year',
  ISO_QTR = 'iso-quarter',
  ISO_WEEK = 'iso-week',
  ISO_WEEKDAY = 'iso-weekday',
  UNKNOWN = 'unknown',
  NONE = 'none',
}

export type ConvertibleToSecondDateTrunc =
  | DateTrunc.SECOND
  | DateTrunc.MINUTE
  | DateTrunc.HOUR
  | DateTrunc.DAY
  | DateTrunc.WEEK;

export type ConvertibleToMonthDateTrunc = DateTrunc.MONTH | DateTrunc.QUARTER | DateTrunc.YEAR;

export const isConvertibleToSecondDateTrunc = (dateTrunc: DateTrunc): dateTrunc is ConvertibleToSecondDateTrunc => {
  return (
    dateTrunc === DateTrunc.SECOND ||
    dateTrunc === DateTrunc.MINUTE ||
    dateTrunc === DateTrunc.HOUR ||
    dateTrunc === DateTrunc.DAY ||
    dateTrunc === DateTrunc.WEEK
  );
};

export const isConvertibleToMonthDateTrunc = (dateTrunc: DateTrunc): dateTrunc is ConvertibleToMonthDateTrunc => {
  return dateTrunc === DateTrunc.MONTH || dateTrunc === DateTrunc.QUARTER || dateTrunc === DateTrunc.YEAR;
};

/// From VPC
export enum DateGranularity {
  UNKNOWN = 'unknown',
  SECOND = 'second',
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
  ISO_YEAR = 'iso-year',
  ISO_QUARTER = 'iso-quarter',
  ISO_WEEK = 'iso-week',
  ISO_WEEKDAY = 'iso-weekday',
}

export const dateTruncFromGranularity = (date?: DateGranularity): DateTrunc => {
  switch (date) {
    case DateGranularity.SECOND: {
      return DateTrunc.SECOND;
    }
    case DateGranularity.MINUTE: {
      return DateTrunc.MINUTE;
    }
    case DateGranularity.HOUR: {
      return DateTrunc.HOUR;
    }
    case DateGranularity.DAY: {
      return DateTrunc.DAY;
    }
    case DateGranularity.ISO_WEEKDAY: {
      return DateTrunc.ISO_WEEKDAY;
    }
    case DateGranularity.WEEK: {
      return DateTrunc.WEEK;
    }
    case DateGranularity.ISO_WEEK: {
      return DateTrunc.ISO_WEEK;
    }
    case DateGranularity.MONTH: {
      return DateTrunc.MONTH;
    }
    case DateGranularity.QUARTER: {
      return DateTrunc.QUARTER;
    }
    case DateGranularity.ISO_QUARTER: {
      return DateTrunc.ISO_QTR;
    }
    case DateGranularity.YEAR: {
      return DateTrunc.YEAR;
    }
    case DateGranularity.ISO_YEAR: {
      return DateTrunc.ISO_YEAR;
    }
    case DateGranularity.UNKNOWN:
    case undefined:
    default: {
      return DateTrunc.UNKNOWN;
    }
  }
};

export const dateGranularityFromTrunc = (dateTrunc?: DateTrunc): DateGranularity => {
  switch (dateTrunc) {
    case DateTrunc.SECOND: {
      return DateGranularity.SECOND;
    }
    case DateTrunc.MINUTE: {
      return DateGranularity.MINUTE;
    }
    case DateTrunc.HOUR: {
      return DateGranularity.HOUR;
    }
    case DateTrunc.DAY: {
      return DateGranularity.DAY;
    }
    case DateTrunc.ISO_WEEKDAY: {
      return DateGranularity.ISO_WEEKDAY;
    }
    case DateTrunc.WEEK: {
      return DateGranularity.WEEK;
    }
    case DateTrunc.ISO_WEEK: {
      return DateGranularity.ISO_WEEK;
    }
    case DateTrunc.MONTH: {
      return DateGranularity.MONTH;
    }
    case DateTrunc.QUARTER: {
      return DateGranularity.QUARTER;
    }
    case DateTrunc.ISO_QTR: {
      return DateGranularity.ISO_QUARTER;
    }
    case DateTrunc.YEAR: {
      return DateGranularity.YEAR;
    }
    case DateTrunc.ISO_YEAR: {
      return DateGranularity.ISO_YEAR;
    }
    case DateTrunc.UNKNOWN:
    case DateTrunc.NONE:
    case undefined:
    default: {
      return DateGranularity.UNKNOWN;
    }
  }
};
